import axios from "axios";
import { BASE_URL } from "App/constants";
import { ObjectiveFieldType } from "Interfaces/Pages/GeminiPromptsInterface";

export const getGeminiPromptsList = async (searchQuery?: string) => {
  const searchParam = searchQuery
    ? `search_query=${encodeURIComponent(searchQuery)}`
    : "";
  const { data } = await axios.get(`${BASE_URL}gemini_prompts?${searchParam}`);
  if (data) {
    return data;
  }
  return { prompts: [], total_count: 0 };
};

export const getGeminiObjectiveFieldUnits = async (): Promise<string[]> => {
  const { data } = await axios.get(`${BASE_URL}constants`, {
    params: { key: "gemini_objective_field_units" },
  });
  return data?.gemini_objective_field_units ?? [];
};

export const updateGeminiPrompt = async (
  id: number,
  payload: { prompt: string; objective_fields: ObjectiveFieldType[] }
) => {
  const { data } = await axios.patch(`${BASE_URL}gemini_prompts/${id}`, {
    gemini_prompt: payload,
  });
  return data;
};

export const createGeminiPrompt = async (
  payload:
    | {
        prompt: string;
        prompt_category: "sport";
        master_sport_id: number;
        objective_fields: ObjectiveFieldType[];
      }
    | {
        prompt: string;
        prompt_category: "exercise";
        exercise_type: string;
        objective_fields: ObjectiveFieldType[];
      }
) => {
  const { data } = await axios.post(`${BASE_URL}gemini_prompts`, {
    gemini_prompt: payload,
  });
  return data;
};

export const getMasterSportsExcluding = async (
  excludeMasterSportIds: number[]
) => {
  const excludeParam =
    excludeMasterSportIds.length > 0
      ? `?exclude_master_sport_ids=${excludeMasterSportIds.join(",")}`
      : "";
  const { data } = await axios.get(`${BASE_URL}master_sports${excludeParam}`);
  if (data) {
    return data;
  }
  return [];
};
